export const API_BASE_URL = "https://sons-pricing-api-production.up.railway.app";
export const PROPERTY_SLUG = "sons-island";
// Son's Island has no overnight inventory of its own — overnight stays are
// fulfilled at our sister property, Son's Geronimo.
export const OVERNIGHT_PROPERTY_SLUG = "geronimo";
export const PROPERTY_NAME = "Son's Island";
export const PROPERTY_PHONE = "(877) 577-7667";

export const CALENDAR_CACHE_TTL_MS = 5 * 60 * 1000;
export const SESSION_KEY = "sgo_booking_session_id";
export const ANALYTICS_FLUSH_MS = 5_000;

// Kill switch for the electronic signature + Son's Hub dispute-evidence
// system. When false the booking flow still displays the Rental
// Agreement and Cancellation Policy and still requires both acceptance
// checkboxes, but it skips the drawn signature and the
// authorization_record.
//
// IMPORTANT INVARIANT (true or false): evidence delivery is ALWAYS
// advisory. It is queued to a durable outbox and delivered in the
// background — it can never delay, gate, or block the guest's path to
// the Checkfront payment iframe.
export const WAIVER_CAPTURE_ENABLED = true;

// ---------------------------------------------------------------------------
// Off-island parking fee surcharge
// ---------------------------------------------------------------------------
// Checkfront taxes EVERY line at the flat 11.3% "Taxes & Fees" rate, and adds a
// FIXED $3.20 fee per extra off-island parking spot (pkg 272). Campground
// admissions (pkg 322) carry NO surcharge — only the flat rate.
//
// Derived from live bookings (charged tax from the Checkfront response):
//   CXVB-130826: $189.00 → $21.36  = 189 × 0.113            (no extras)
//   AHFC-130826: $199.00 → $22.49  = 199 × 0.113            (5 people, no car)
//   HLZG-130826: $184.00 → $24.00  = 184 × 0.113 + 3.20     (1 car)
//   LBZQ-130826: $184.00 → $24.00  = 184 × 0.113 + 3.20     (1 car)
//   DMQB-130826: $179.00 → $23.43  = 179 × 0.113 + 3.20     (1 car, 3 people)
//   FBHH-130826: $139.00 → $22.11  = 139 × 0.113 + 3.20×2   (2 cars) ✓ per-car
// AHFC (people-only) rules out the earlier "admissions or parking" trigger and
// the 19.32% per-package rate; FBHH confirms the fee is PER CAR, not per
// booking. All six live bookings tie to the cent on this model.
export const PARKING_SURCHARGE_PACKAGE_IDS = ["272"] as const;
export const PARKING_SURCHARGE_AMOUNT = 3.2;

export const OVERRIDE_TAX_LINE_NAME = "Off-island parking fee";

// Son's Hub — single API surface for all dispute-evidence traffic.
export const HUB_FUNCTIONS_BASE =
  "https://jhgvpqnesquocndbzygl.supabase.co/functions/v1";
// Unified evidence endpoint (idempotent on booking_code).
export const HUB_EVIDENCE_ENDPOINT = `${HUB_FUNCTIONS_BASE}/booking-evidence`;
// Legacy endpoint kept ONLY as an automatic fallback for the case where
// the unified endpoint has not been deployed on Hub yet (404/405).
export const HUB_EVIDENCE_FALLBACK_ENDPOINT = `${HUB_FUNCTIONS_BASE}/capture-booking-agreement`;
export const HUB_BLOCKLIST_ENDPOINT = `${HUB_FUNCTIONS_BASE}/check-company-blocklist`;

// Mutable "active property" used by the booking API layer. Defaults to the
// page's primary property but flips to OVERNIGHT_PROPERTY_SLUG while the user
// is browsing overnight cabins so availability/pricing/booking calls land on
// Son's Geronimo's Checkfront account.
let activeProperty: string = PROPERTY_SLUG;
export function setActiveProperty(slug: string): void {
  activeProperty = slug;
}
export function getActiveProperty(): string {
  return activeProperty;
}
